import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { IJsonMap } from '@/interfaces/JSON';

import Translate from '@/shared/translate';

Vue.use(VueI18n);

interface ITranslation {
  [index: string]: IJsonMap;
}

interface ITranslationInclusion {
  namespace: string;
  translations: ITranslation;
}

const messages = {};

export function includeTranslation(translationInclusion: ITranslationInclusion): void {
  Object.keys(translationInclusion.translations).reduce((acc: ITranslation, key: string, index: number) => {
    const actualLocale = acc[key] || {};
    acc[key] = { ...actualLocale, [translationInclusion.namespace]: translationInclusion.translations[key] };
    return acc;
  }, messages);
}

const numberFormats = {
  'pt-br': {
    currency: {
      style: 'currency', currency: 'BRL'
    },
    percent: {
      style: 'percent', minimumFractionDigits: 2,
    }
  },
};

function createI18n(): VueI18n {
  return new VueI18n({
    locale: 'pt-br',
    messages,
    numberFormats
  });
}

includeTranslation({
  namespace: 'App',
  translations: {
    'pt-br': Translate.pt_BR
  },
});

export default createI18n();
